<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_scheme_types',
          })
        "
        class="buttons"
      >
        <WorkDocsSchemeTypeModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-scheme_type']['dialog_delete'][
              'udalit-tip-chertezha'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkDocsSchemeTypeModal from 'components/setting/workDocsSchemeType/WorkDocsSchemeTypeModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkDocsSchemeTypeTableItem',
  components: { WorkDocsSchemeTypeModal, DeleteModal },
  props: ['item'],
}
</script>
